const TYPE = 'aggregationResultProcessor.filters';
function process(type, result, query, context) {
  const {
    relationship
  } = context;
  if (!result?.buckets) {
    return [];
  }
  const ref = `${relationship.ref}.agg`;
  return Object.entries(result.buckets).map(([key, value]) => {
    const obj = {
      id: `${ref}-${key}`,
      type: 'aggResult',
      ref
    };
    const data = {
      key,
      value: value.count
    };
    obj.data = data;
    return obj;
  }).sort((itemA, itemB) => {
    const keyA = itemA.data.key;
    const keyB = itemB.data.key;
    if (!query.filters) {
      return 1;
    }
    const indexA = query.filters.findIndex(item => {
      return item.name === keyA;
    });
    const indexB = query.filters.findIndex(item => {
      return item.name === keyB;
    });
    return indexA - indexB;
  });
}
export default {
  TYPE,
  process
};